<template lang="pug">
div.txt__notoR14(
  v-if="!props.isLoggedIn",
  class="relative group flex items-center bg-[#749F54] !text-white rounded-md px-[30px] py-[10px] transition-all duration-200 cursor-not-allowed"
  @mouseenter="showTooltip"
  @mouseleave="hideTooltipWithDelay"
)
  span(class="material-symbols-outlined") add
  |フォロー

  div.txt__notoR14(
    class="text-left absolute transition-all duration-200 bg-[#7EA35C] top-0 right-0 -translate-y-[125%] rounded-[20px] p-[24px] w-[270px] shadow-lg z-50",
    :class="isTooltipVisible ? 'visible opacity-100 pointer-events-auto' : 'invisible opacity-0 pointer-events-none'",
    @mouseenter="showTooltip"
    @mouseleave="hideTooltipWithDelay"
  )
    p フォロー機能は会員限定です。
    p ログインして新着通知を受け取りましょう！
    a(
      :href="`${baseUrl}/mypage/login?redirect=${encodeURIComponent(currentPath)}`",
      class="!underline block !text-white rounded-md px-[30px] pt-[10px] text-center font-bold"
    ) [ログイン/新規登録へ]
    div(
      class="absolute left-1/2 -bottom-[10px] w-5 h-5 bg-[#7EA35C] rotate-45 -translate-x-1/2"
    )

button.txt__notoR14(
  v-else-if="props.isLoggedIn && isFollowing === false",
  class="flex items-center bg-[#749F54] text-white rounded-md px-[30px] py-[10px] transition-all duration-200 hover:!bg-[#7EA35C] active:!bg-[#446F23]",
  @click.prevent="handleFollow"
) 
  span(class="material-symbols-outlined") add
  |フォロー

div(
  v-else-if="isFollowing === true && props.mode === 'projectDetail'",
  class="flex items-center bg-white text-[#7E7E7E] border border-[#7E7E7E] rounded-md px-[30px] py-[10px]"
)
  span(class="material-symbols-outlined") check
  |フォロー中

div(
  v-else-if="isFollowing === true && props.mode === 'mypage'",
)
  button.txt__notoR14(
    class="flex items-center bg-white text-[#7E7E7E] border border-[#7E7E7E] rounded-md px-[30px] py-[10px] cursor-pointer",
    :uk-toggle="`target: #unfollowModal__${props.businessId}`"
  )
    span(class="material-symbols-outlined") check
    |フォロー中
  div(
    :id="`unfollowModal__${props.businessId}`",
    class="uk-flex-top",
    uk-modal
  )
    div(class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical")
      h2(class="uk-modal-title txt__notoSB18 !mb-10") フォローを解除しますか？
      .uk-flex.uk-flex-center.uk-flex-middle.gap-10
        button(
          class="flex-1 uk-modal-close border border-[#7E7E7E] rounded-md px-[30px] py-[10px]" type="button"
        ) キャンセル
        button(
          @click.prevent="handleUnfollow",
          class="flex-1 uk-modal-close bg-[#F03E53] text-white rounded-md px-[30px] py-[10px]" type="button"
        ) 解除

</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'; 
import axios from 'axios';

const baseUrl = (window as any).baseUrl || '';
const currentPath = window.location.pathname + window.location.search;

const emit = defineEmits<{
  (e: 'unfollow', businessId: number): void
}>()

onMounted(async () => {
  // console.log('VueFollowButton mounted');
  // console.log(props.isLoggedIn);
  // console.log(props.businessId);

  //- ログインしていない場合は早期リターン
  if (!props.isLoggedIn) return;
  if (!props.businessId) return;

  try {
    const response = await axios.get(`${baseUrl}/business-follow/${props.businessId}`);
    isFollowing.value = response.data.is_followed;
  } catch (error) {
    console.error(error);
  }
});

const props = withDefaults(defineProps<{
  isLoggedIn: boolean;
  businessId: number;
  mode?:  'projectDetail' | 'mypage';
}>(), {
  mode: 'projectDetail',
});

const isFollowing = ref<boolean | null>(null);
const isTooltipVisible = ref<boolean>(false);
const isSubmitting = ref<boolean>(false);

let tooltipTimer: number | null = null;

/**
 * ツールチップを表示
 */
function showTooltip() {
  if (tooltipTimer) window.clearTimeout(tooltipTimer);
  isTooltipVisible.value = true;
}

/**
 * ツールチップを遅延で非表示
 */
function hideTooltipWithDelay() {
  if (tooltipTimer) window.clearTimeout(tooltipTimer);
  tooltipTimer = window.setTimeout(() => {
    isTooltipVisible.value = false;
  }, 350);
}

/**
 * フォローを送信
 */
async function handleFollow() {
  //- 送信中は早期リターン
  if (isSubmitting.value) return;

  try {
    //- 送信中フラグを立てる
    isSubmitting.value = true;

    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    //- フォローを送信
    const response = await axios.post(
      `${baseUrl}/business-follow/${props.businessId}`,
      {},
      {
        headers: csrf ? {
          'X-CSRF-TOKEN': csrf,
        } : {},
      }
    );

    isFollowing.value = response.data.is_followed;
  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}

/**
 * フォローを解除
 */
async function handleUnfollow() {
  //- 送信中は早期リターン
  if (isSubmitting.value) return;

  try {
    //- 送信中フラグを立てる
    isSubmitting.value = true;

    const csrf = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;

    const response = await axios.delete(
      `${baseUrl}/business-follow/${props.businessId}`,
      {
        headers: csrf ? {
          'X-CSRF-TOKEN': csrf,
        } : {},
      }
    )

    isFollowing.value = response.data.is_followed;

    if (response.data.success && response.data.is_followed === false) {
      emit('unfollow', props.businessId);
    }

  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}

</script>

<style lang="sass" scoped>

</style>
